import React, { useEffect, useState } from "react";
import { Button } from "../../../components";
import { useNavigate, useLocation } from "react-router-dom";
import { auth, db } from "../../../config/firebaseConfig";
import { collection, query, where, getDocs } from "firebase/firestore";
// import StudentCard from "./StudentCard";
import SchoolLogo from "../school/SchoolLogo";
import { IoWarningOutline } from "react-icons/io5";
import { sendVerificationEmail } from "../dashboardFunctions";
import { LuLoader2 } from "react-icons/lu";
import DashboardInstructions from "./DashboardIns";
// import { PDFDownloadLink } from "@react-pdf/renderer";
// import PDFContentParent from "../pdf/PDFContentParent";
import { GAEventTrack } from "../../../utils/hooks/GA_events";
// import StudentLoadingCard from "./StudentLoadingCard";
import { useSelector } from "react-redux";
import PractidoAppPaymentModule from "./PractidoAppPaymentModule";
// import VerifyPhoneModal from "./VerifyPhoneModal";
// import VerifyPhoneModal from "./VerifyPhoneModal";

import { Sparkles, ArrowRight } from "lucide-react";

const ParentDashboard = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isAiLabOffer = searchParams.get("offer") === "ai-lab";

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [verificationEmailSent, setVerificationEmailSent] = useState(null);
  const {
    userDetails: parentsDetails,
    loading: parentDetailsLoading,
    schoolDetails,
  } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAiLabOffer) {
      navigate("/parentDashboard/ai-lab/enrol", { replace: true });
    }
  }, [isAiLabOffer, navigate]);

  const [activeEnrollments, setActiveEnrollments] = useState([]);
  const [pendingEnrollments, setPendingEnrollments] = useState([]);

  useEffect(() => {
    const fetchEnrollments = async () => {
      const parentId = parentsDetails?.id || auth?.currentUser?.uid;
      if (!parentId) return;
      try {
        // Query verified enrollments
        const verifiedQ = query(
          collection(db, "ai-lab"),
          where("parentId", "==", parentId),
          where("paymentStatus", "==", "verified")
        );
        const verifiedSnap = await getDocs(verifiedQ);
        const verifiedList = verifiedSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setActiveEnrollments(verifiedList);

        // Query pending enrollments
        const pendingQ = query(
          collection(db, "ai-lab"),
          where("parentId", "==", parentId),
          where("paymentStatus", "==", "pending")
        );
        const pendingSnap = await getDocs(pendingQ);
        const pendingList = pendingSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setPendingEnrollments(pendingList);
      } catch (err) {
        console.error("Error fetching AI Lab enrollments:", err);
      }
    };
    fetchEnrollments();
  }, [parentsDetails]);
  // const { students, loading: studentDetailsLoading } = useSelector(
  //   (state) => state.parentStudents
  // );

  return (
    <div className="container py-12 space-y-6">
      {/* todo : uncomment the line below for verify phone modal */}
      {/* {parentsDetails && parentsDetails.phoneVerified !== true && !parentDetailsLoading && (
        <VerifyPhoneModal parentsDetails={parentsDetails} />
      )} */}
      {parentsDetails?.emailVerified === false && (
        <div className="bg-[#FFDBD2] text-[#FF0707] p-3 flex gap-2 items-center justify-center rounded-xl">
          <IoWarningOutline className="w-5 h-5 " />
          <span className="text-base">
            Please verify your email address to unlock more features and
            services. We've sent a verification link to your registered email.
          </span>
          {verificationEmailSent ? (
            <span className="font-bold">✓ Sent</span>
          ) : (
            <button
              className="font-extrabold hover:underline flex items-center gap-2"
              onClick={() => {
                sendVerificationEmail({
                  actionUrl: "parentDashboard",
                  setLoading: setLoading,
                  setVerificationEmailSent: setVerificationEmailSent,
                });
                //GA event tracking
                GAEventTrack({
                  event: "parent_dashboard_verif_email_sent",
                  data: {
                    uid: auth?.currentUser?.uid,
                    email: auth?.currentUser?.email,
                  },
                });
              }}
            >
              Resend Link
              {loading?.resend && (
                <span>
                  <LuLoader2 className="animate-spin" />
                </span>
              )}
            </button>
          )}
        </div>
      )}
      <div className="parents-dashbaord-content space-y-4">
        {parentDetailsLoading ? (
          <div className="col-span-2 flex items-center justify-center gap-5">
            <div className="bg-gray-400 w-20 h-20 overflow-hidden flex items-center justify-center rounded-full flex-shrink-0">
              <div className="w-full h-full bg-gray-400 animate-pulse flex items-center justify-center"></div>
            </div>

            <div className="flex flex-col gap-1">
              <div className="w-48 h-8 bg-gray-300 rounded-lg animate-pulse" />
              <div className="w-32 h-4 bg-gray-300 rounded-lg animate-pulse" />
              <div className="w-40 h-4 bg-gray-300 rounded-lg animate-pulse" />
            </div>
          </div>
        ) : (
          parentsDetails?.schoolId && (
            <div>
              <SchoolLogo schoolDetails={schoolDetails} />
            </div>
          )
        )}

        <div className="space-y-6">
          {/* Pending Enrollment Alert */}
          {pendingEnrollments.length > 0 && (
            <div className="p-4 rounded-2xl border border-amber-200 bg-amber-50 text-left flex flex-col sm:flex-row sm:items-center justify-between gap-4 shadow-3xs">
              <div className="space-y-1">
                <h4 className="font-extrabold text-amber-900 text-sm flex items-center gap-1.5">
                  <span className="animate-pulse">⚠️</span> Pending Enrolment Found
                </h4>
                <p className="text-xs text-amber-700 font-semibold">
                  You have a pending enrolment. Complete the payment checkout to activate your child's courses.
                </p>
              </div>
              <div className="flex-shrink-0">
                <button
                  onClick={() => navigate("/parentDashboard/ai-lab/enrol")}
                  className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-xl text-xs font-extrabold shadow-sm transition"
                >
                  Resume Checkout &rarr;
                </button>
              </div>
            </div>
          )}

          {/* Render Active Enrolled Children Section if they have any active registrations */}
          {activeEnrollments.length > 0 && (
            <div className="bg-white rounded-3xl border border-blue-100 p-6 shadow-sm hover:shadow-md transition-all flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600 flex-shrink-0">
                  <Sparkles className="w-6 h-6 text-amber-500" />
                </div>
                <div>
                  <h3 className="text-lg font-black text-slate-800">My AI Lab Classes</h3>
                  <p className="text-sm text-slate-500 font-medium">View your children's active courses and join live classes</p>
                </div>
              </div>
              <button 
                onClick={() => navigate("/parentDashboard/ai-lab/classes")}
                className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-bold shadow-sm transition-colors w-full sm:w-auto flex-shrink-0"
              >
                View Classes
              </button>
            </div>
          )}

          {/* Promo Card: Hide if they have active enrollments */}
          {!isAiLabOffer && activeEnrollments.length === 0 && (
            <div className="relative overflow-hidden rounded-2xl bg-[#DBF2F7] border border-[#BCE3EB] p-6 sm:p-8 shadow-sm hover:shadow-md transition-all duration-300">
              {/* Decorative background blobs/glows */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/40 rounded-full blur-3xl -mr-16 -mt-16 pointer-events-none" />
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-100/50 rounded-full blur-2xl -ml-16 -mb-16 pointer-events-none" />

              <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                <div className="space-y-3 max-w-3xl">
                  {/* Badge */}
                  <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/80 text-blue-700 text-xs font-bold border border-[#A4D5DF]">
                    <Sparkles className="w-3.5 h-3.5 text-amber-500 animate-pulse" />
                    <span>Practido AI LAB Program</span>
                  </div>

                  {/* Headline */}
                  <h3 className="text-xl md:text-2xl font-extrabold tracking-tight text-gray-900">
                    Enrol Your Child in a Live Online Course
                  </h3>

                  {/* Subheadline */}
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed font-medium">
                    Select your course, complete payment, and we’ll confirm your child’s first class within 24 hours - directly on WhatsApp.
                  </p>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col items-center gap-2.5 flex-shrink-0 self-center">
                  <Button
                    version="secondary"
                    text="Enrol Now"
                    handleClick={() => navigate("/parentDashboard/ai-lab/enrol")}
                  />
                  <button
                    type="button"
                    onClick={() => navigate("/parentDashboard/ai-lab")}
                    className="text-xs font-black text-blue-700 hover:text-blue-900 flex items-center gap-1 group transition-all"
                  >
                    Show Details
                    <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
                  </button>
                </div>
              </div>
            </div>
          )}

          <PractidoAppPaymentModule
            schoolDetails={schoolDetails}
            parentsDetails={parentsDetails}
          />
        </div>

        {/* <h3>PRACTIDO Online Olympiad 2024 Participant Information</h3> */}
        {/* <div className="flex gap-4 flex-wrap">
          {parentDetailsLoading || studentDetailsLoading ? (
            <>
              <StudentLoadingCard />
              <StudentLoadingCard />
            </>
          ) : (
            students?.map((student) => (
              <StudentCard student={student} key={student.id} />
            ))
          )}
        </div> */}
        {/* <div>
          <Button
            text={`Add ${students?.length ? "More" : ""} Participants`}
            version="secondary"
            isDisabled={parentsDetails?.emailVerified === false}
            handleClick={() => {
              navigate("/onboarding/step1");
              //GA event tracking
              GAEventTrack({
                event: "add_participant_btn",
                data: {
                  uid: auth?.currentUser?.uid,
                  email: auth?.currentUser?.email,
                },
              });
            }}
          />
          {parentsDetails?.emailVerified === false && (
            <p className="text-sm text-[#FF0707] p-2">
              Verify your email id to add participants.
            </p>
          )}
        </div> */}
      </div>
      {/* <div className="dash-blue-card gap-4">
        <div className="col-md-6 w-full bg-[#DBF2F7] rounded-xl p-4 flex flex-col gap-1 justify-center">
          <h3 className="text-lg font-bold">Mark Your Calendars!</h3>
          <p className="font-medium">
            The Practido Online Olympiad exam is happening on{" "}
            <strong>[Date of Exam]</strong>.
          </p>
          <Link
            to="/examlanding"
            // target="_blank"
            className="bg-white p-2 px-4 rounded-full font-semibold w-fit hover:no-underline"
            style={{ boxShadow: "0px 3px 0px #DFDFDF" }}
          >
            Preview Exam Details
          </Link>
        </div>
        <div className="col-md-6 w-full bg-[#DBF2F7] rounded-xl p-4 flex flex-col gap-1 justify-center">
          <p className="text-base font-medium">
            Ensure a smooth Olympiad experience! Download the Information PDF
            for your child's competition details.
          </p>

          <button
            className="bg-white p-2 px-4 rounded-full font-semibold w-fit"
            style={{ boxShadow: "0px 3px 0px #DFDFDF" }}
            onClick={() => {
              //GA event tracking
              GAEventTrack({
                event: "parent_dshbrd_download_pdf",
                data: {
                  uid: auth?.currentUser?.uid,
                  email: auth?.currentUser?.email,
                },
              });
            }}
          >
            <PDFDownloadLink
              document={
                <PDFContentParent schoolDetails={schoolDetails || null} />
              }
              fileName="Practido-Olympiad-Instructions.pdf"
            >
              {({ blob, url, loading, error }) =>
                loading ? "Loading ..." : "Click here to download the PDF"
              }
            </PDFDownloadLink>
          </button>
        </div>
      </div> */}

      <>
        <DashboardInstructions placement="parent" />
      </>
    </div>
  );
};

export default ParentDashboard;
